export const WEBFLOW_THANK_YOU_URL =
  "https://www.themilesmarket.com/submission-thank-you";
export const WEBFLOW_BASE_URL = "https://www.themilesmarket.com";
